import EnvironmentConfig from '../interfaces/EnvironmentConfig';
import saravanaConfig from './saravana';

type ConfigMap = { [env: string]: EnvironmentConfig };

const configsMap: ConfigMap = {
  saravana: saravanaConfig,
};

const localOverrides = import.meta.glob<{ default: Record<string, unknown> }>(
  './local-*.json',
  { eager: true }
);

const getEnvConfigs = () => {
  const currentEnv = import.meta.env.VITE_DEPLOY_ENV || 'dev';

  if (!currentEnv || !configsMap[currentEnv]) {
    throw new Error('No Env Found');
  }

  const localConfig =
    localOverrides[`./local-${currentEnv}.json`]?.default ?? {};

  return { ...configsMap[currentEnv], ...localConfig };
};

export default getEnvConfigs();
